import apiRoutes from "@/src/apiRoutes";
import Tabs from "@/src/components/Tabs/Tabs";
import { textVariants } from "@/src/components/Text/Text";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/src/components/shad/accordion";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/src/components/shad/popover";
import { useNotifications } from "@/src/hooks/useNotifications";
import api from "@/src/utils";
import { useMutation } from "@tanstack/react-query";
import { Spin } from "antd";
import _ from "lodash";
import { BellIcon } from "lucide-react";
import moment from "moment";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";

const Notifications = () => {
  const { t } = useTranslation();
  const trans = (key: string) => t(`app.navbar.${key}`);
  const { notifications, refetch, categories } = useNotifications();
  const [markId, setMarkId] = useState<number>();
  const [type, setType] = useState("inbox");

  //To fiilter the active notifications
  const activeNotifications =
    notifications &&
    notifications?.filter((notification) => !notification?.opened);

  const notToShow = type === "inbox" ? notifications : activeNotifications;

  const markNotification = async (item: Notifications) => {
    if (item?.opened) {
      toast.info("Notification already marked");
      return;
    }
    setMarkId(item?.id);
    const res = await api.post(apiRoutes.openNotifications, {
      type: "open",
      id: item?.id,
    });
    return res.data;
  };

  const { mutate, isLoading: readLoad } = useMutation({
    mutationKey: ["read_notification"],
    mutationFn: markNotification,
    onSuccess: (data) => {
      if (data?.success) {
        refetch();
        toast.success("Notification marked as read");
      }
    },
  });

  const filteredNotifications = (id: number) => {
    const res = notifications?.filter((not) => not.category === id);
    return res;
  };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <div className="relative inline-block">
          <p className="border boder-gray-300 p-1 cursor-pointer rounded-full">
            <BellIcon className="h-6 w-6 text-gray-400" />
            {!_.isEmpty(notToShow) && (
              <span className="absolute top-0 right-0 inline-flex items-center justify-center p-1 text-xs font-bold leading-none text-red-100 transform translate-x-1/2 -translate-y-1/2 bg-blue-600 rounded-full">
                {/* 0 */}
              </span>
            )}
          </p>
        </div>
        {/* <Button variant="outline">Open popover</Button> */}
      </PopoverTrigger>
      <PopoverContent className="md:w-[30vw] w-80 mr-10 max-h-[700px] min-h-[400px] overflow-y-scroll p-0">
        <div className="sticky top-0 w-full bg-white dark:bg-grey-900 px-2 z-50">
          <Tabs
            space="4"
            tabs={[
              { name: trans("notifications.inbox"), value: "inbox" },
              { name: trans("notifications.unread"), value: "unread" },
            ]}
            activeTab={type}
            setTab={setType}
          />
        </div>
        <div className="overflow-y-scroll px-1 mt-2">
          {categories.map((category) => (
            <Accordion
              key={category?.id}
              type="single"
              collapsible
              className="w-full flex flex-col px-4 "
            >
              <AccordionItem
                value={category?.id.toString()}
                className=" rounded-md"
              >
                <AccordionTrigger className="focus:outline-none">
                  <div
                    key={category.id}
                    className="flex items-center justify-between p-2 "
                  >
                    <div className="flex items-center">
                      <div className="flex-shrink-0 h-6 w-6 mr-2">
                        <img
                          src={category.icon}
                          className="h-6 w-6"
                          alt="icon"
                        />
                      </div>
                      <div className="text-left">
                        <p
                          className={textVariants({
                            size: "sm",
                            font: "semibold",
                          })}
                        >
                          {category.title}
                        </p>
                        <span
                          className={textVariants({
                            variant: "desc",
                            size: "sm",
                          })}
                        >
                          {_.truncate(category.description, { length: 100 }) ??
                            "No new notifications"}
                        </span>
                      </div>
                    </div>
                  </div>
                </AccordionTrigger>
                <AccordionContent className="bg-gray-50 dark:bg-grey-900">
                  <div>
                    <div className="grid gap-3  ">
                      {type !== "announcements" &&
                        filteredNotifications(category?.id)?.map(
                          (notification, key: number) => (
                            <Spin
                              key={key}
                              spinning={notification?.id === markId && readLoad}
                            >
                              <div
                                className={`w-full cursor-pointer px-3 dark:bg-grey-700 hover:bg-grey-50  dark:hover:bg-grey-600 ${
                                  notification?.opened
                                    ? ""
                                    : "border-l-4 border-indigo-300  "
                                } py-4  flex justify-between`}
                                onClick={() => mutate(notification)}
                              >
                                <div className="flex flex-col">
                                  <span className="font-bold">
                                    {notification?.title}
                                  </span>
                                  <div
                                    className={textVariants({ size: "sm" })}
                                    dangerouslySetInnerHTML={{
                                      __html: notification?.message,
                                    }}
                                  />
                                  <span
                                    className={textVariants({
                                      size: "xs",
                                      variant: "desc",
                                    })}
                                  >
                                    {moment(notification.created_at).fromNow()}
                                  </span>
                                </div>
                              </div>
                            </Spin>
                          )
                        )}
                    </div>
                  </div>
                </AccordionContent>
              </AccordionItem>
            </Accordion>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default Notifications;
